var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-top-list"},[_c('titleComponent',{attrs:{"titleName":"资源分布"}}),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"margin-top":"8px"}},[_c('leftTopLeft'),_vm._v(" "),_c('leftTopRight')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e8ef74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/patrolScreenMini/components/left/left-top.vue
// module id = null
// module chunks = 